// Responsive
GLOBAL.windowSize = {};

GLOBAL.responsive = () => {
  GLOBAL.windowSize.width = window.innerWidth || document.documentElement.clientWidth;
  GLOBAL.windowSize.height = window.innerHeight || document.documentElement.clientHeight;

  // Set CSS variable to correct window height calculation for mobile browsers
  const vh = GLOBAL.windowSize.height * .01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // If changed only window height
  GLOBAL.onlyWindowHeightChanged = false;
  if (GLOBAL.windowSize?.previousWidth == GLOBAL.windowSize.width) {
    GLOBAL.onlyWindowHeightChanged = true;
  }
  GLOBAL.windowSize.previousWidth = GLOBAL.windowSize.width;

  // Responsive menu
  const mobileMenuLink = document.querySelector('.mobile-menu-link'),
        mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  if (mobileMenuLink && !mobileMenuLink.dataset.hasListener) {
    mobileMenuLink.dataset.hasListener = true;
    mobileMenuLink.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.toggle('nav-opened');
    }, false);
  }
  if (mobileMenuOverlay && !mobileMenuOverlay.dataset.hasListener) {
    mobileMenuOverlay.dataset.hasListener = true;
    mobileMenuOverlay.addEventListener('click', () => {
      document.body.classList.remove('nav-opened');
    }, false);
  }

  // Responsive manipulations
  if (GLOBAL.windowSize.width < 768) {
  }
}


window.addEventListener('DOMContentLoaded', () => {

  // Useful classes for responsive design
  const html = document.querySelector('html');
  html.classList.add(GLOBAL.isTouchscreen ? 'isTouchscreen' : 'isDesktop');

  // Make responsive
  GLOBAL.responsive();

  // Preload video
  const preloadVideo = (source, success, error) => {
    const req = new XMLHttpRequest();

    req.open('GET', source, true);
    req.responseType = 'blob';

    req.onload = function () {
      if (this.status === 200) {
        success(URL.createObjectURL(this.response));
      } else {
        error();
      }
    }
    req.onerror = error;

    req.send();
  };

  // Universal link
  const navLink = document.querySelector('nav .nav-link');
  if (navLink) {
    // Video background for the main page
    if (document.body.classList.contains('index-page')) {
      const video = document.querySelector('.video-background video');
      const playVideo = () => {
        navLink.classList.remove('shown');
        video.classList.add('active');
        video.play();
      };
      preloadVideo(video.dataset.src, function (resp) {
        video.src = resp;
        navLink.classList.add('shown');
        navLink.addEventListener(GLOBAL.isTouchscreen ? 'click' : 'mouseenter', (event) => {
          event.preventDefault();
          playVideo();
        }, {
          once: true
        });
        setTimeout(() => {
          playVideo();
        }, 15000);
      });
    // Close main navigation for all other pages
    } else {
      navLink.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('.mobile-menu-link').click();
      }, false);
    }
  }

  // Mobile left navigation
  const leftHeading = document.querySelector('aside#left h1');
  if (leftHeading) {
    leftHeading.addEventListener('click', (event) => {
      if (GLOBAL.windowSize.width < 768) {
        document.body.classList.toggle('nav-left-opened');
        event.target.nextElementSibling.classList.toggle('visible');
      }
    }, false);
  }

  // Image modals
  Fancybox.bind('.photo-container img', {
    idle: false,
    contentClick: false,
    Thumbs: false,
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ['close']
      },
      items: {
        close: {
          tpl: '<button class="f-button fancybox__close" title="{{CLOSE}}" data-fancybox-close></button>'
        }
      }
    }
    //l10n: Fancybox.l10n.ru
  });

}, false);


window.addEventListener('resize', () => {

  // Make responsive
  GLOBAL.responsive();

}, false);


window.addEventListener('load', () => {

  // Make responsive
  GLOBAL.responsive();

  const filmsNav = document.querySelector('aside#left');
  if (filmsNav) {
    // Smart navigation for films
    filmsNav.classList.add('shown');
    const filmsVideos = document.querySelectorAll('.video-background video'),
          scrollLink = filmsNav.querySelector('.scroll-link');
    const scrollSpy = new ScrollSpy(document.querySelectorAll('main .film h2'), filmsNav.querySelector('.nav-left'), {
      offsetTop: (parseFloat(window.getComputedStyle(document.querySelector('main .film'), null).getPropertyValue('padding-top'))) * -1,
      onActive: (index, link) => {
        filmsVideos.forEach((el) => {
          el.classList.remove('active');
          el.pause();
        });
        filmsVideos[index].classList.add('active');
        filmsVideos[index].play();
        if (index == filmsVideos.length - 1) {
          scrollLink.classList.add('go-back');
        } else {
          scrollLink.classList.remove('go-back');
        }
      }
    });

    // Fade when Vimeo Player plays
    document.querySelectorAll('main .film .film-video iframe').forEach((iframe) => {
      const player = new Vimeo.Player(iframe);
      player.getVideoId().then((id) => {
        player.on('play', () => {
          document.body.classList.add('film-playing');
        });
        player.on('pause', function() {
          document.body.classList.remove('film-playing');
        });
        player.on('ended', function() {
          document.body.classList.remove('film-playing');
        });
      }).catch((error) => {
        console.error(error);
      });
    });
  }

}, false);